// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgRestoreSizeUp14 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 14 14"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.33301 12.4166V13.6666H1.99967C1.0792 13.6666 0.333008 12.9204 0.333008 12V1.99996C0.333008 1.07948 1.0792 0.333293 1.99967 0.333293H11.9997C12.9201 0.333293 13.6663 1.07948 13.6663 1.99996V5.33329H12.4163V1.99996C12.4163 1.76984 12.2298 1.58329 11.9997 1.58329H1.99967C1.76956 1.58329 1.58301 1.76984 1.58301 1.99996V12C1.58301 12.2301 1.76956 12.4166 1.99967 12.4166H5.33301ZM5.54134 7.20825C5.54134 6.28778 6.28753 5.54159 7.20801 5.54159L10.5413 5.54159L10.5413 6.79159L7.67634 6.79159L12.6499 11.7663C12.894 12.0104 12.894 12.4061 12.6499 12.6502C12.4059 12.8943 12.0101 12.8943 11.7661 12.6502L6.79134 7.67492L6.79134 10.5416H5.54134L5.54134 7.20825Z"
				/>
			</Svg>
		);
	}
);
SvgRestoreSizeUp14.defaultProps = {
	size: 14,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgRestoreSizeUp14;
